import React from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './css.scss'
import deleteIcon from './images/delete.svg'
import editIcon from './images/edit.svg'
import addIcon from './images/add.svg'
import askingIcon from './images/asking.svg'
import warningIcon from './images/warning.svg'
import questionIcon from './images/question.svg'
import saveIcon from './images/save.svg'
import dangerIcon from './images/danger.svg'
import failIcon from './images/fail.svg'

const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-info btn-lg',
      cancelButton: 'btn btn-default btn-lg',
      actions: 'text-center',
    },
  }),
)

const isFunc = item => {
  return item && {}.toString.call(item) === '[object Function]'
}

const buildText = (text = null, isTitle = false) => {
  if (!text) {
    return null
  }

  if (React.isValidElement(text)) {
    return <div className="sa-color">{text}</div>
  } else {
    if (isTitle) {
      return <h4 className="sa-color">{text}</h4>
    }
    return <div className="sa-color">{text}</div>
  }
}

const defaultModalClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-info btn-lg btn-transition-default',
  cancelButton: 'btn btn-default btn-lg',
  actions: 'text-center',
}

const defaultDeleteClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-transition-default btn-error-custom btn-lg',
  cancelButton: 'btn btn-default btn-lg',
  actions: 'text-center',
}

const defaultAddClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-success-custom-dark btn-lg btn-transition-default',
  cancelButton: 'btn btn-default btn-lg',
  actions: 'text-center',
}

const defaultEditClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-warning-custom btn-lg btn-transition-default',
  cancelButton: 'btn btn-default btn-lg',
  actions: 'text-center',
}

const defaultSuccessAlertClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-success-custom btn-lg btn-transition-default',
  actions: 'text-center',
}

const customDefaultSuccessAlertClass = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-success-custom-dark btn-lg btn-transition-default',
  actions: 'text-center',
  image: 'custom-image-alert',
}

const customDefaultSuccessAlertClass2 = {
  container: 'add-list-box-modal',
  confirmButton: 'btn btn-success-custom-dark btn-lg btn-transition-default',
  actions: 'text-center',
  cancelButton: 'btn btn-outline-success btn-lg',
  denyButton: 'btn btn-danger btn-lg',
  image: 'custom-image-alert',
}

const customToastSuccess = {
  closeButton: 'btn-close-toast',
  title: 'text-success-toast mr-5',
  icon: 'icon-success-toast',
  popup: 'popup-success-toast',
}

export const SwConfirmCustom = ({
  html,
  onConfirm = null,
  onCancel = null,
  customClass = null,
  confirmButtonText = 'OK',
  cancelButtonText = 'Cancel',
  hideCancelButtonText = false,
  hideConfirmButtonText = false,
  willClose = () => {},
  timer = null,
}) => {
  let modalClass = customClass ? customClass : defaultModalClass

  return (
    <>
      {ReactSwal.fire({
        html: html,
        showCancelButton: hideCancelButtonText ? false : true,
        showConfirmButton: hideConfirmButtonText ? false : true,
        willClose: willClose,
        customClass: modalClass,
        reverseButtons: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        ...(timer && { timer: timer }),
      }).then(result => {
        if (result.value && isFunc(onConfirm)) {
          onConfirm()
        }
        if (!result.value && isFunc(onCancel)) {
          onCancel()
        }
      })}
    </>
  )
}

export const SwConfirmCustomV2 = ({
  // html,
  imageUrl = null,
  onConfirm = null,
  onCancel = null,
  onDeny = null,
  title = '',
  type = '',
  description = '',
  confirmButtonText = 'OK',
  cancelButtonText = 'Cancel',
  denyButtonText = 'Deny',
  hideCancelButtonText = false,
  hideConfirmButtonText = false,
  hideDenyButtonText = true,
  showCloseButton = false,
  willClose = () => {},
  timer = null,
}) => {
  const html = (
    <div className="mt-4">
      {/* {buildText(title, true)} */}
      {buildText(description)}
    </div>
  )

  switch (type.toLowerCase()) {
    case 'delete':
      imageUrl = deleteIcon
      break
    case 'add':
      imageUrl = addIcon
      break
    case 'edit':
      imageUrl = editIcon
      break

    case 'asking':
      imageUrl = askingIcon
      break

    case 'warning':
      imageUrl = warningIcon
      break

    case 'question':
      imageUrl = questionIcon
      break

    //เพิ่มicon save
    case 'save':
      imageUrl = saveIcon
      break

    case 'fail':
      imageUrl = failIcon
      break

    case 'danger':
      imageUrl = dangerIcon
      break
    default:
      break
  }

  return (
    <>
      {ReactSwal.fire({
        html: html,
        imageUrl: imageUrl,
        title: title,
        showCloseButton: showCloseButton,
        showCancelButton: hideCancelButtonText ? false : true,
        showConfirmButton: hideConfirmButtonText ? false : true,
        showDenyButton: hideDenyButtonText ? false : true,
        willClose: willClose,
        reverseButtons: true,
        customClass: customDefaultSuccessAlertClass2,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        denyButtonText: denyButtonText,
        ...(timer && { timer: timer }),
      }).then(result => {
        if (result.value && isFunc(onConfirm)) {
          onConfirm()
        }
        if (result.value == undefined && isFunc(onCancel)) {
          onCancel()
        }
        if (result.value !== undefined && !result.value && isFunc(onDeny)) {
          onDeny()
        }
      })}
    </>
  )
}

export const SwConfirm = ({
  type,
  title = null,
  description = null,
  onConfirm = null,
  onCancel = null,
  confirmButtonText = 'OK',
  cancelButtonText = 'Cancel',
  hideCancelButtonText = false,
  hideConfirmButtonText = false,
  willClose = () => {},
  timer = null,
}) => {
  console.log('sw confirm input', type, title, description, buildText(title), buildText(description))
  let html
  let customClass = null

  let altText = ''
  let srcIcon = null

  switch (type.toLowerCase()) {
    case 'delete':
      srcIcon = deleteIcon
      altText = 'delete this item ?'
      customClass = defaultDeleteClass
      break
    case 'add':
      srcIcon = addIcon
      altText = 'add this item ?'
      customClass = defaultAddClass
      break
    case 'edit':
      srcIcon = editIcon
      altText = 'edit this item ?'
      customClass = defaultEditClass
      break

    case 'asking':
      srcIcon = askingIcon
      altText = 'ask for approval ?'
      customClass = defaultAddClass
      break

    case 'warning':
      srcIcon = warningIcon
      altText = 'ask for approval ?'
      customClass = defaultAddClass
      break

    case 'question':
      srcIcon = questionIcon
      altText = 'ask for approval ?'
      customClass = defaultAddClass
      break

    //เพิ่มicon save
    case 'save':
      srcIcon = saveIcon
      altText = 'save for approval ?'
      customClass = defaultAddClass
      break

    case 'fail':
      srcIcon = failIcon
      altText = 'approval fail ?'
      customClass = defaultAddClass
      break

    case 'danger':
      srcIcon = dangerIcon
      altText = 'reject for approval ?'
      customClass = defaultAddClass
      break
    default:
      break
  }

  console.log('sw confirm output', html, onConfirm, onCancel, customClass)

  html = (
    <div>
      <div>
        <img className="sa-main-icon" src={srcIcon} alt={altText} />
      </div>
      {buildText(title, true)}
      {buildText(description)}
    </div>
  )

  customClass = defaultAddClass

  return SwConfirmCustom({
    html,
    onConfirm,
    onCancel,
    customClass,
    confirmButtonText,
    cancelButtonText,
    hideCancelButtonText,
    hideConfirmButtonText,
    willClose,
    timer,
  })
}

// icon มี 5 แบบ success,error,warning,info,question
export const SwAlert = ({ icon, title = null, description = null, onConfirm = null, customClass = null, confirmButtonText = 'OK' }) => {
  let modalClass = customClass ? customClass : icon.toLowerCase() == 'success' ? defaultSuccessAlertClass : defaultModalClass

  const html = (
    <div className="mt-4">
      {buildText(title, true)}
      {buildText(description)}
    </div>
  )
  return (
    <>
      {ReactSwal.fire({
        html: html,
        icon: icon,
        customClass: modalClass,
        confirmButtonText: confirmButtonText,
      }).then(result => {
        if (isFunc(onConfirm)) {
          onConfirm()
        }
      })}
    </>
  )
}

export const SwAlertCustom = ({ imageUrl, title = null, description = null, onConfirm = null, customClass = null, confirmButtonText = 'OK' }) => {
  const html = (
    <div className="mt-4">
      {buildText(title, true)}
      {buildText(description)}
    </div>
  )
  return (
    <>
      {ReactSwal.fire({
        html: html,
        imageUrl: imageUrl,
        customClass: customDefaultSuccessAlertClass,
        confirmButtonText: confirmButtonText,
      }).then(result => {
        if (isFunc(onConfirm)) {
          onConfirm()
        }
      })}
    </>
  )
}



export const SwToast = ({
  title = 'ยืนยันรายการเรียบร้อยแล้ว',
  backgroundColor = '#4ACE8F',
  iconColor = '#DADADA',
  icon = 'success',
  useIconColor = false,
  timer = 8000,
}) => {
  let bgColor = backgroundColor

  if (useIconColor == true) {
    switch (icon) {
      case 'success':
        bgColor = '#4ACE8F'
        break
      case 'warning':
        bgColor = '#F9C153'
        break
      case 'error':
        bgColor = '#F0536F'
        break
      default:
        bgColor = '#4ACE8F'
        break
    }
  }

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    showCloseButton: true,
    timer: timer,
    background: bgColor,
    customClass: customToastSuccess,
    iconColor: iconColor,
  })
  Toast.fire({
    icon: icon,
    title: title,
  })
}

export const failedLoadToast = error => {
  SwToast({
    title: 'พบปัญหาในการบันทึกข้อมูล',
    useIconColor: true,
    icon: 'error',
  })
}

export default SwConfirmCustom
